// extracted by mini-css-extract-plugin
module.exports = {"OnlineStoreRightsNa":"OnlineStoreRightsNa_OnlineStoreRightsNa__TSi1F"};